import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FnMenuDataService } from 'foundation';

@Injectable({
	providedIn: 'root',
})
export class MenuRedirectService{
	constructor(private menuDataSvcs:FnMenuDataService,private router: Router) {
		
    }
    
    redirectToUrlWithMenuId(menuId:string){
        // this.menuDataSvcs.setActiveMenuId(menuId);
        const menuDetail=this.menuDataSvcs.getMenuItemMap()[menuId].detail;
        // const url=menuDetail.len > 0?menuDetail.url+'/subMenuContent': menuDetail.url;
        // console.log(this.menuDataSvcs.getMenuItemMap());
        this.router.navigate([menuDetail.url]);
    }
}
